'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _blocks = require('../../blocks');

var _MenusList = require('./MenusList');

var _MenusList2 = _interopRequireDefault(_MenusList);

var _menuPropTypes = require('./menuPropTypes');

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MenuGroupItem(_ref) {
  var TextRenderer = _ref.TextRenderer,
      expanded = _ref.expanded,
      expandedMenus = _ref.expandedMenus,
      handleExpandMenuClick = _ref.handleExpandMenuClick,
      last = _ref.last,
      location = _ref.location,
      menuGroup = _ref.menuGroup,
      menuGroupsLoading = _ref.menuGroupsLoading;

  return _react2.default.createElement(
    _blocks.LeftNav.MenuGroupItem,
    null,
    _react2.default.createElement(_MenusList2.default, {
      TextRenderer: TextRenderer,
      expanded: expanded,
      expandedMenus: expandedMenus,
      handleExpandMenuClick: handleExpandMenuClick,
      location: location,
      menuGroup: menuGroup,
      menuGroupsLoading: menuGroupsLoading
    }),
    _react2.default.createElement(_blocks.LeftNav.MenuGroupsDivider, {
      modifiers: (0, _lodash.compact)([expanded && 'expanded', last && 'last'])
    })
  );
}

MenuGroupItem.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  expandedMenus: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  handleExpandMenuClick: _propTypes2.default.func.isRequired,
  last: _propTypes2.default.bool.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  // eslint-disable-next-line react/no-typos
  menuGroup: _menuPropTypes2.default.menuGroup.isRequired,
  menuGroupsLoading: _propTypes2.default.bool.isRequired
};

exports.default = MenuGroupItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/LeftNav/MenuGroupItem.js
// module id = 1671
// module chunks = 2